/**
 * Cart 21+ checkbox ↔ checkout / express checkout.
 * Plain script (no imports): works with theme import map and survives manual asset uploads.
 * Loaded globally from snippets/scripts.liquid so listeners exist before the drawer morphs in.
 */
(function () {
  'use strict';

  const CART_UPDATE = 'cart:update';
  const DISCOUNT_UPDATE = 'discount:update';

  const CHECKBOX_SELECTOR = '[data-cart-age-acknowledgement]';
  const CHECKOUT_SELECTOR = '.cart__checkout-button';
  const EXPRESS_SELECTOR = '[data-cart-age-gate-express]';

  /**
   * @param {Element} cartItems
   */
  function syncCartCheckoutAgeGate(cartItems) {
    if (!(cartItems instanceof HTMLElement) || !cartItems.matches('cart-items-component')) return;

    const checkbox = cartItems.querySelector(CHECKBOX_SELECTOR);
    const checkout = cartItems.querySelector(CHECKOUT_SELECTOR);
    const express = cartItems.querySelector(EXPRESS_SELECTOR);

    if (!checkbox || !(checkout instanceof HTMLButtonElement)) return;

    // Snippet only renders this checkbox when the cart has lines; no item-count parsing (avoids morph/ref bugs).
    const canCheckout = /** @type {HTMLInputElement} */ (checkbox).checked;

    checkout.disabled = !canCheckout;
    if (canCheckout) {
      checkout.removeAttribute('disabled');
    } else {
      checkout.setAttribute('disabled', '');
    }

    if (express instanceof HTMLElement) {
      if (canCheckout) {
        express.removeAttribute('inert');
      } else {
        express.setAttribute('inert', '');
      }
    }
  }

  function syncAllCartCheckoutAgeGates() {
    document.querySelectorAll('cart-items-component').forEach((el) => syncCartCheckoutAgeGate(el));
  }

  /** @param {Event} event */
  function onCheckboxChange(event) {
    const target = event.target;
    if (!(target instanceof HTMLElement) || !target.matches(CHECKBOX_SELECTOR)) return;
    const cartItems = target.closest('cart-items-component');
    if (cartItems) queueMicrotask(() => syncCartCheckoutAgeGate(cartItems));
  }

  /** Label / note clicks: target may not be the input; sync after toggle. */
  /** @param {Event} event */
  function onAgeConfirmationClick(event) {
    const target = event.target;
    if (!(target instanceof HTMLElement)) return;
    const row = target.closest('.cart__age-confirmation');
    if (!row) return;
    const checkbox = row.querySelector(CHECKBOX_SELECTOR);
    if (!(checkbox instanceof HTMLInputElement)) return;
    queueMicrotask(() => {
      const cartItems = checkbox.closest('cart-items-component');
      if (cartItems) syncCartCheckoutAgeGate(cartItems);
    });
  }

  syncAllCartCheckoutAgeGates();

  const w = /** @type {Window & { __shopifyCartAgeGateListeners?: boolean }} */ (window);
  if (w.__shopifyCartAgeGateListeners) return;
  w.__shopifyCartAgeGateListeners = true;

  document.addEventListener('change', onCheckboxChange);
  document.addEventListener('input', onCheckboxChange);
  document.addEventListener('click', onAgeConfirmationClick);

  document.addEventListener(CART_UPDATE, () => queueMicrotask(syncAllCartCheckoutAgeGates));
  document.addEventListener(DISCOUNT_UPDATE, () => queueMicrotask(syncAllCartCheckoutAgeGates));

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncAllCartCheckoutAgeGates);
  }
})();
